module.exports = __webpack_public_path__ + "static/img/logo03.53545df9.png";